/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import axios, { AxiosInstance } from 'axios';

import { VApplication } from '../application/index';
import { DeviceInfoService } from './device-info.service';

const SERVICE_NAME = 'dummy-rest.service';
const { LoggerModule } = require("@vlinder-web/logger-module-react");
const log: any = LoggerModule.getInstance();

const is = require('is_js');

interface IProps {
    baseURL: string;
    timeout?: number;
    headers?: any;
}

const getDeviceInfoService = () => {
    const app = VApplication.getInstance();
    return app?.getSync('services.DeviceInfoService') as DeviceInfoService;
};

export class DummyRestService {
    name = SERVICE_NAME;
    private static instance: DummyRestService;

    private api: AxiosInstance;

    private constructor(props: IProps | any) {
        const deviceInfoService = getDeviceInfoService();
        this.api = axios.create({
            baseURL: props.baseURL,
            timeout: props.timeout ?? 30000, // 30 secs
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                ...{ ...deviceInfoService.getDeviceInfo() },
                ...{ ...deviceInfoService.getAppInfo() },
                ...{ ...(props.headers || {}) },
            },
        });
        this.report();
    }

    static getInstance(props: IProps | any = {}) {
        if (!this.instance) {
            this.instance = new DummyRestService(props);
        }
        return this.instance;
    }
    async init() {}

    async dummySignIn({ param1, param2 }: { param1: string; param2: string }) {
        try {
            log?.info(SERVICE_NAME, 'param1 : ', param1);
            if (
                is.not.existy(param1) ||
                is.not.string(param1) ||
                is.empty(param1)
            ) {
                throw Error(`param1 cannot be null or empty`);
            }
            if (
                is.not.existy(param2) ||
                is.not.string(param2) ||
                is.empty(param2)
            ) {
                throw Error(`param2 cannot be null or empty`);
            }
            const res = await this.api.get(`/`);
            log.info(`dummySignIn`, res?.data);
            return res;
        } catch (err) {
            log?.error('Error in dummySignIn', err?.message);
            throw Error(err?.message);
        }
    }

    private report() {
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
        log?.info(SERVICE_NAME, 'Module Report');
        log?.info(SERVICE_NAME, '⦿ Name: ' + this.name);
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
    }
}
